import Vue from "vue";
import VueRouter from "vue-router";
import { Dialog } from 'vant';
import allApi from "@/http/allApi.js"
Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "homePage",
        meta: {
            title: '溶瘤病毒论坛',
        },
        component: resolve => require(["@/views/homePage.vue"], resolve)
    },
    {
        path: "/lineList",
        name: "lineList",
        meta: {
            title: '溶瘤病毒论坛',
            keepAlive: true
        },
        component: resolve => require(["@/views/lineList.vue"], resolve)
    },
    {
        path: "/detiles/:id",
        name: "detiles",
        meta: {
            title: '溶瘤病毒论坛',
        },
        component: resolve => require(["@/views/detiles.vue"], resolve)
    },
    {
        path: "/detilseNew",
        name: "detilseNew",
        meta: {
            title: '溶瘤病毒论坛',
        },
        component: resolve => require(["@/views/detilseNew.vue"], resolve)
    },
    {
        path: "/detilesZJ",
        name: "detilesZJ",
        meta: {
            title: '溶瘤病毒论坛',
        },
        component: resolve => require(["@/views/detilesZJ.vue"], resolve)
    },
    {
        path: "/list/:id",
        name: "List",
        meta: {
            title: '溶瘤病毒论坛',
            keepAlive: true
        },
        component: resolve => require(["@/views/list.vue"], resolve)
    }
];
const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    let uuid = getCookie("uuid");
    if (to.name != "homePage") {
        if (uuid == undefined || uuid == null || uuid == "") {
            window.location.href=' http://' + window.location.host + "/user/login?url=" + encodeURIComponent(window.location.href);
            // allApi.getUuid().then(res=>{
            //     setCookie("uuid",res.data.data.uuid)
            //     next();
            // })
            // if (to.query.uuid) {
            //     setCookie("uuid",to.query.uuid)
            //     next();
            // } else {
            //     Dialog.confirm({
            //             title: '提示',
            //             message: '是否前往登录',
            //         })
            //         .then(() => {
            //             allApi.getLoginurl({
            //                 redirecturl: "/#" + to.fullPath
            //             }).then(res => {
            //                 location.href = res.data.data.url
            //             })
            //         })
            //         .catch(() => {
            //             return;
            //         });
            // }
        } else {
            next();
        }
    } else {
        next();
    }
});
//设置名称为name,值为value的Cookie
function setCookie(name, value) {
    var expdate = new Date();
    expdate.setTime(expdate.getTime() +365 * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/";
}

//获取cookie
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
export default router;